import React, { useState } from 'react'
import { ModalDialogContainer } from '@common/modal'
import { useModal } from '@common/GlobalModal'
import {
  SiteBoxFileView,
  SiteBoxFileViewProps,
  ViewerDocumentItem,
} from './SiteBoxFileView'

export interface SiteBoxDocumentViewerModalProps {
  organisationId: number
  projectId: number
  documents: ViewerDocumentItem[]
  initialItemId?: number | string
  readOnly?: boolean
  renderActions?: SiteBoxFileViewProps['renderActions']
  onClose?: () => void
}

export const SiteBoxDocumentViewerModal: React.FC<
  SiteBoxDocumentViewerModalProps
> = ({
  organisationId,
  projectId,
  documents,
  initialItemId,
  readOnly,
  renderActions,
  onClose,
}) => {
  const { hideModal } = useModal()
  const [currentIndex, setCurrentIndex] = useState(() =>
    Math.max(
      documents.findIndex((item) => item.id === initialItemId),
      0,
    ),
  )

  const handleClose = () => {
    hideModal()
    onClose?.()
  }

  return (
    <ModalDialogContainer
      PaperProps={{ sx: { maxWidth: '95vw', height: '95vh', flex: 1 } }}
      onClose={handleClose}
    >
      <SiteBoxFileView
        organisationId={organisationId}
        projectId={projectId}
        documents={documents}
        currentIndex={currentIndex}
        onChangeIndex={setCurrentIndex}
        readOnly={readOnly}
        renderActions={renderActions}
        onClose={handleClose}
      />
    </ModalDialogContainer>
  )
}
